import { ViewHook } from "phoenix_live_view";

class AnimatedImageLoad extends ViewHook {
  mounted() {
    if (this.el.nodeName !== "IMG") {
      console.error("AnimatedImageLoad: expected IMG element, got", this.el.nodeName);
      return;
    }

    const image = this.el as HTMLImageElement;

    this.onLoaded = this.onLoaded.bind(this);
    this.onError = this.onError.bind(this);

    image.addEventListener("load", this.onLoaded);
    image.addEventListener("error", this.onError);

    // Sometimes the image is already loaded by the time we attach the event listeners,
    // so checking for that
    if (image.complete) {
      if (image.naturalWidth) {
        this.onLoaded();
      } else {
        this.onError();
      }
    }
  }

  destroyed() {
    this.el.removeEventListener("load", this.onLoaded);
    this.el.removeEventListener("error", this.onError);
  }

  private onLoaded() {
    this.el.classList.remove("opacity-0");
  }

  private onError() {
    this.el.setAttribute("hidden", "");
  }
}

export default AnimatedImageLoad;
